var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotoBustInSilhouette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6434 68.4395V70.7207H7.35742V68.4395C7.35742 59.4855 18.7066 55.1512 31.3105 54.2387V53.6113C26.0066 52.0145 21.273 48.0223 18.9348 41.4637C16.5395 40.6082 15.1707 32.7379 15.798 31.7113C15.3418 28.4035 12.2051 2.4543 36.5004 2.2832C60.7387 2.39727 57.659 28.2895 57.1457 31.6543C57.773 32.6809 56.4043 40.5512 54.009 41.4066C51.7277 47.9652 46.9941 52.0145 41.6902 53.6113V54.1816C54.3512 55.2082 65.6434 59.9988 65.6434 68.4395Z",
    fill: "#CFCEC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoBustInSilhouette);
export default __webpack_public_path__ + "static/media/noto_bust-in-silhouette.5e94a0e53a654e4bf1942f073a3c8c04.svg";
export { ForwardRef as ReactComponent };